module.exports = __webpack_public_path__ + "static/Caley-detail-desktop-a678e15731821f66d58a48ef7530d753.png";